import * as React from "react"
export const Svg_052 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={58}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M41.82 4.902c-3.46-3.461-9.092-3.461-12.553 0l-.201.201-.201-.2a8.819 8.819 0 0 0-6.277-2.6 8.82 8.82 0 0 0-6.277 2.6c-3.461 3.46-3.461 9.092 0 12.553L29.065 30.21l12.756-12.755c3.46-3.461 3.46-9.093 0-12.554Z"
    />
    <path fill="url(#b)" d="M0 30.213h7.99v25.485H0V30.213Z" />
    <path
      fill="url(#c)"
      d="M49.985 28.375 38.852 39.508h-17.09v-3.406h14.365c-.577-3.34-3.495-5.889-6.998-5.889H11.396v22.08h24.276L58 29.962l-1.588-1.588a4.55 4.55 0 0 0-6.427 0Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={20.815}
        x2={33.473}
        y1={6.488}
        y2={29.025}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={1.848}
        x2={12.771}
        y1={34.036}
        y2={39.578}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={22.173}
        x2={30.245}
        y1={30.833}
        y2={54.949}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)